module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('h1', [_vm._v("Registrieren")])]), _vm._v(" "), _c('p', [_vm._v("\n        Vielen Dank! Check deine Mails, du solltest eine Bestätigung erhalten haben.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5093300","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signup-complete.vue
// module id = 239
// module chunks = 0